import { useEffect } from 'react';

export function useDebouncedEffect(effect, dependencies = [], delay) {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
  }, [...dependencies, delay]);
}
